import actionTypes from '../../actions/actionTypes';

const initialState = {
    availableCurrencies: null,
    infoIsComplete: true,
    unpaidBilling: [],
    unpaidInvoices: [],
};

const OrganizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_SUPPORTED_CURRENCIES:
            return {
                ...state,
                availableCurrencies: action.payload.availableCurrencies,
            };
        case actionTypes.ORG_INFO_IS_COMPLETE:
            return {
                ...state,
                infoIsComplete: action.payload.isComplete,
            };
        case actionTypes.UNPAID_BILLING:
            return {
                ...state,
                unpaidBilling: action.payload.unpaidBilling,
            };
        case actionTypes.UNPAID_INVOICES:
            return {
                ...state,
                unpaidInvoices: action.payload.unpaidInvoices,
                quoteRestrictionDays: action.payload.quoteRestrictionDays,
            };
        case actionTypes.CLEAR_UNPAID_INVOICES:
            return {
                ...state,
                unpaidInvoices: [],
                quoteRestrictionDays: null,
            };
        default:
            return state;
    }
};

export default OrganizationReducer;
